import React, { Component } from "react";
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
  verify_admin,
  resetLoginState,
  getGeneralUse
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import { hasAnyPermission, hasPermission } from "./Permission";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };
  }

  componentDidMount() {
    this.initMenu();
    // this.props.verify_admin();
    this.props.getGeneralUse();
  }
  componentDidUpdate(prevProps) {
    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {
      this.props.getGeneralUse();
    }

  }

  UNSAFE_componentDidUpdate(prevProps) {

    if (prevProps !== this.props) {

      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }

    }
    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {

      this.setState({ pathName: this.props.router.location.pathname }, () => {

        this.initMenu();
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
  }


  render() {
    const permissions = (this.props.verifyAdmin && this.props.verifyAdmin.user && this.props.verifyAdmin.user.data && this.props.verifyAdmin.user.data.permissions) || [];

    const sidebarItems = [
      {
        label: "MAIN",
        isTitle: true,
      },
      {
        label: "Dashboard",
        icon: "ri-home-6-line",
        route: "/dashboard",
        permission: "view-dashboard",
      },
      {
        label: "OPERATIONS",
        isTitle: true,
      },
      {
        label: "Patient",
        icon: "ri-group-line",
        route: "/patient",
        permission: "view-member",
      },
      {
        label: "Doctors",
        icon: "ri-nurse-line",
        route: "/doctor",
        permission: "view-clinic",
      },
      // {
      //   label: "Testimonials",
      //   icon: "ri-clipboard-line",
      //   route: "/testimonials",
      //   permission: "view-testimonial",
      // },
      {
        label: "Clinics",
        icon: "ri-store-2-line",
        route: "/clinic",
        permission: "view-clinic",
      },

      {
        label: "Appointments",
        icon: "ri-calendar-event-line",
        route: "/appointment",
        permission: "view-appointment",
      },
      {
        label: "Packages",
        icon: "ri-folder-open-line",
        route: "/packages",
        permission: "view-package",
      },
      {
        label: "Pre-Employment",
        icon: "ri-bank-line",
        route: "/pre-employment",
        permission: "view-preemployment_appointment",
      },
      {
        label: "Teleconsultation",
        icon: "ri-stethoscope-line",
        route: "/teleconsult",
        permission: "view-teleconsultation",
      },
      // {
      //   label: "Campaigns",
      //   icon: "ri-focus-3-line",
      //   route: "/campaigns",
      //   permission: "view-campaign",
      // },
      {
        label: "ADMINISTRATIVE",
        isTitle: true,
      },
      {
        label: "Staffs",
        icon: "ri-team-line",
        route: "/staff-listing",
        permission: "view-admin",
      },
      {
        label: "Settings",
        icon: "ri-settings-2-line",
        route: "/#",
        permission: ["create-general-setting", "view-admin", "view-role"],
        submenu: [
          {
            label: "Roles",
            route: "/role-permissions",
            permission: "view-role",
          },
          {
            label: "Payment Configuration",
            route: "/payment-configuration",
            permission: "edit-general-setting",
          },
          {
            label: "Public Holiday",
            route: "/date-configuration",
            permission: "edit-general-setting",
          },
          {
            label: "General Settings",
            route: "/general",
            permission: "edit-general-setting",
          },
        ],
      },
      // {
      //   label: "Export Data",
      //   icon: "ri-download-2-line",
      //   route: "/#",
      //   permission: ["export-dashboard"],
      //   submenu: [
      //     {
      //       label: "Patient",
      //       link: "/",
      //       permission: "export-dashboard",
      //     },
      //     {
      //       label: "Clinic Appointments",
      //       link: "/",
      //       permission: "export-dashboard",
      //     },
      //     {
      //       label: "Pre-Employment",
      //       link: "/",
      //       permission: "export-dashboard",
      //     },
      //     {
      //       label: "Teleconsultation",
      //       link: "/",
      //       permission: "export-dashboard",
      //     },
      //   ],
      // },

      // {
      //   label: "Download Data",
      //   icon: "ri-download-2-line",
      //   link: "/",
      //   permission: "view-preemployment_appointment",
      // },
    ];

    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {
              sidebarItems.map((item, index) => (
                <li key={index}>
                  {
                    item.permission ?
                      item.link ?
                        <a href={`/`} target="_blank" rel="noreferrer" alt="download" className={item.submenu ? "has-arrow waves-effect" : "waves-effect"} style={{ display: (hasAnyPermission(permissions, item.permission) ? "" : "none") }}>
                          <i className={item.icon}></i>
                          <span className="ms-1">{item.label}</span>
                        </a>
                        :
                        <Link to={item.route} className={item.submenu ? "has-arrow waves-effect" : "waves-effect"} style={{ display: (hasAnyPermission(permissions, item.permission) ? "" : "none") }}>
                          <i className={item.icon}></i>
                          <span className="ms-1">{item.label}</span>
                        </Link>
                      :
                      item.isTitle ?
                        <div className="menu-title">{item.label}</div>
                        :
                        <Link to={item.route} className={item.submenu ? "has-arrow waves-effect" : "waves-effect"}>
                          <i className={item.icon}></i>
                          <span className="ms-1">{item.label}</span>
                        </Link>
                  }

                  {item.submenu && (
                    <ul className="sub-menu">
                      {item.submenu.map((subItem, subIndex) => (
                        hasPermission(permissions, subItem.permission) &&
                        <li key={subIndex}><Link to={subItem.route}>{subItem.label}</Link></li>
                      ))}
                    </ul>
                  )}
                </li>
              ))
            }
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    verifyAdmin: state.Login.verifyAdmin,
  };
};

export default withRouter(connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader,
  verify_admin,
  getGeneralUse,
  resetLoginState
})(withTranslation()(SidebarContent)));
